import { JSX } from 'react'

import { IconProps } from '../../icon'

const EdFisica: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M32.1155 32.4838C23.7135 40.8058 9.25439 39.977 9.25439 39.977C9.25439 39.977 9.37214 26.6009 17.7741 18.279C26.176 9.95703 39.6806 9.84003 39.6806 9.84003C39.6806 9.84003 40.5174 24.1617 32.1155 32.4838Z'
      fill='#D7D861'
    />
    <path
      d='M10.8872 39.6955C10.1557 39.6955 9.41166 39.6803 8.65417 39.649L8.07118 39.6248L8.04693 39.047C7.60068 28.3526 10.3389 20.2272 16.1856 14.8987C25.3563 6.53981 38.7272 8.08655 39.2919 8.1558L39.7814 8.21655L39.8424 8.70104C39.9129 9.26029 41.4742 22.5039 33.0345 31.5879C28.0318 36.9723 20.5881 39.6955 10.8872 39.6955ZM9.29292 38.4148C11.2044 38.4743 13.0314 38.4278 14.7666 38.2798L14.7291 38.2676C15.2431 36.6686 14.8189 34.9383 13.6216 33.7523C12.5244 32.6648 10.9667 32.2216 9.47041 32.5466C9.28892 34.3993 9.22917 36.3558 9.29292 38.4148ZM10.4419 31.1856C11.9484 31.1856 13.4154 31.7714 14.5184 32.8643C15.9276 34.2603 16.5011 36.2451 16.0741 38.1468C22.8963 37.3396 28.2655 34.8626 32.0947 30.7446C36.4057 26.1084 37.9642 20.1899 38.4799 15.677C36.6687 15.9622 34.817 15.3825 33.492 14.07C32.2717 12.8618 31.678 11.212 31.818 9.55604C27.3203 10.1148 21.5716 11.6928 17.0371 15.8297C12.9736 19.5367 10.4924 24.7027 9.62116 31.2439C9.89441 31.2051 10.1692 31.1856 10.4419 31.1856ZM33.109 9.41879C32.9177 10.7908 33.3775 12.1805 34.3885 13.1823C35.5015 14.285 37.0882 14.7255 38.6047 14.3732C38.7862 12.023 38.6954 10.194 38.6304 9.35629C37.7319 9.28754 35.7009 9.19129 33.109 9.41879ZM16.2404 32.0454L15.3439 31.1574L17.7988 28.7261L15.8356 26.7814L16.7321 25.8934L18.6953 27.8381L20.3381 26.2109L18.3748 24.2662L19.2713 23.3782L21.2348 25.3224L22.8773 23.6959L20.9141 21.7512L21.8106 20.8632L23.774 22.8079L25.4168 21.1807L23.4535 19.236L24.35 18.348L26.3133 20.2922L27.956 18.6657L25.9928 16.721L26.8893 15.833L28.8528 17.7772L31.3077 15.346L32.2045 16.234L29.75 18.6652L31.7132 20.6094L30.8165 21.4974L28.8533 19.5532L27.2105 21.1804L29.1735 23.1247L28.277 24.0127L26.3138 22.0684L24.671 23.6957L26.6343 25.6399L25.7375 26.5279L23.7743 24.5837L22.1316 26.2109L24.0948 28.1551L23.1983 29.0431L21.2351 27.0989L19.5921 28.7261L21.5556 30.6709L20.6591 31.5589L18.6956 29.6141L16.2404 32.0454Z'
      fill='black'
    />
  </svg>
)

export default EdFisica
